import React, { useEffect } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { Input } from "reactstrap";
import { usePharmacy } from "../../../../_helper/PharmacyProvider";
import { getStateTaxCodeLabel } from "../../../PharmacyManageTax/taxConfigUtils";
import { useCountryStateSelect } from "../../../../Hooks/useCountryStateSelect";
import CountrySelect from "../../../Common/CountrySelect";
import StateSelect from "../../../Common/StateSelect";

export const NewCustomerModal = ({
	t,
	show,
	onHide,
	newCustomerData,
	onChange,
	errors,
	onSubmit,
}) => {
	const { pharmacyPOS } = usePharmacy();
	const {
		country,
		state,
		states,
		statesLoading,
		showStateCode,
		onCountryChange,
		onStateChange,
		reset: resetLocation,
	} = useCountryStateSelect({ enabled: !!show });

	const stateTaxCodeLabel = getStateTaxCodeLabel(pharmacyPOS, t, country);

	useEffect(() => {
		if (!show) resetLocation();
	}, [show, resetLocation]);

	const handleCountryChange = (option) => {
		onCountryChange(option);
		onChange({
			country: option?.label || "",
			state: "",
			stateCode: "",
		});
	};

	const handleStateChange = (option) => {
		onStateChange(option);
		onChange({
			state: option?.label || "",
			stateCode: showStateCode ? option?.gstCode || "" : "",
		});
	};

	const handleModalHide = () => {
		resetLocation();
		onHide();
	};

	return (
		<Modal show={show} onHide={handleModalHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>{t("Create New Customer")}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form>
					<Form.Group className="mb-3">
						<Form.Label>
							{t("Name")} <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							type="text"
							value={newCustomerData.name}
							onChange={(e) => onChange({ name: e.target.value })}
							isInvalid={!!errors.name}
							placeholder={t("Enter customer name")}
						/>
						<Form.Control.Feedback type="invalid">
							{errors.name}
						</Form.Control.Feedback>
					</Form.Group>

					<div className="mb-3">
						<label className="form-label">
							{t("Mobile Number")} <span className="text-danger">*</span>
						</label>
						<PhoneInput
							country="in"
							value={`${newCustomerData.phoneCode || ""}${newCustomerData.mobileNumber || ""}`}
							onChange={(value, data) =>
								onChange({
									mobileNumber: value.replace(data.dialCode, ""),
									phoneCode: `+${data.dialCode}`,
								})
							}
						/>
						{errors.mobileNumber && (
							<div className="text-danger mt-1">{errors.mobileNumber}</div>
						)}
					</div>

					<Row>
						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">{t("Country")}</label>
								<CountrySelect
									value={country}
									onChange={handleCountryChange}
									placeholder={t("Search country...")}
									inModal
								/>
							</div>
						</Col>

						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">{t("State")}</label>
								<StateSelect
									options={states}
									value={state}
									onChange={handleStateChange}
									placeholder={
										country ? t("Select state") : t("Select country first")
									}
									isDisabled={!country}
									isLoading={statesLoading}
									inModal
								/>
								{errors.state && (
									<div className="text-danger mt-1">{errors.state}</div>
								)}
							</div>
						</Col>
					</Row>

					<Row>
						{showStateCode && (
							<Col md={6}>
								<div className="mb-3">
									<label className="form-label">{stateTaxCodeLabel}</label>
									<Input
										type="text"
										value={newCustomerData.stateCode || ""}
										readOnly
										placeholder={t("Auto-filled")}
									/>
								</div>
							</Col>
						)}

						<Col md={showStateCode ? 6 : 12}>
							<div className="mb-3">
								<label className="form-label">{t("City")}</label>
								<Input
									type="text"
									value={newCustomerData.city || ""}
									onChange={(e) => onChange({ city: e.target.value })}
									placeholder={t("Enter city")}
								/>
							</div>
						</Col>
					</Row>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="primary" onClick={onSubmit}>
					{t("Create Customer")}
				</Button>
				<Button variant="secondary" onClick={handleModalHide}>
					{t("Cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default NewCustomerModal;
